import { render, staticRenderFns } from "./primary_form.vue?vue&type=template&id=1379f9e4"
import script from "./primary_form.vue?vue&type=script&lang=js"
export * from "./primary_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports